import axios from 'axios';
import { getApiUrl } from '../../config/api';

export default class EditGrupouViewController {
  constructor() {
    this.grupou = {
      GrupouCode: '',
      GrupouName: '',
      EsActivo: true
    };
    this.loading = false;
    this.saving = false;
    this.error = null;
    this.grupouCode = null;
  }

  // Inicializar el controlador con el código del grupo
  async initialize(grupouCode) {
    this.grupouCode = grupouCode;
    if (grupouCode) {
      await this.loadGrupou();
    } else {
      this.error = 'Código de grupo no válido';
    }
  }

  // Cargar datos del grupo
  async loadGrupou() {
    this.loading = true;
    this.error = null;

    try {
      const response = await axios.post(getApiUrl('/api/Grupou/lectura'), 
        { GrupouCode: this.grupouCode },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (response.data) {
        this.grupou = response.data;
      } else {
        this.error = 'Grupo no encontrado';
      }
    } catch (error) {
      console.error('Error al cargar grupo:', error);
      this.error = 'No se pudo cargar el grupo. Por favor, intente nuevamente.';
    } finally {
      this.loading = false;
    }
  }

  // Actualizar campo del formulario
  updateField(field, value) {
    this.grupou[field] = value;
  }

  // Validar formulario
  validateForm() {
    if (!this.grupou.GrupouName || !this.grupou.GrupouName.trim()) {
      return false;
    }
    return true;
  }

  // Guardar cambios del grupo
  async saveGrupou() {
    if (this.saving) {
      throw new Error('Ya se está guardando el grupo');
    }

    this.saving = true;
    this.error = null;

    try {
      const response = await axios.post(getApiUrl('/api/Grupou/guardar'), this.grupou);
      return response;
    } catch (error) {
      console.error('Error al actualizar grupo:', error);
      this.error = 'Error al actualizar el grupo. Por favor, intente de nuevo.';
      throw error;
    } finally {
      this.saving = false;
    }
  }

  // Getters para el estado
  getGrupou() {
    return this.grupou;
  }

  isLoading() {
    return this.loading;
  }

  isSaving() {
    return this.saving;
  }

  getCurrentError() {
    return this.error;
  }
}